export default __webpack_public_path__ + "static/media/instagram.0d3e4639.svg";